import { render, staticRenderFns } from "./batchNumberDetail.vue?vue&type=template&id=2e9101ab&scoped=true"
import script from "./batchNumberDetail.vue?vue&type=script&lang=js"
export * from "./batchNumberDetail.vue?vue&type=script&lang=js"
import style0 from "./batchNumberDetail.vue?vue&type=style&index=0&id=2e9101ab&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9101ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e9101ab')) {
      api.createRecord('2e9101ab', component.options)
    } else {
      api.reload('2e9101ab', component.options)
    }
    module.hot.accept("./batchNumberDetail.vue?vue&type=template&id=2e9101ab&scoped=true", function () {
      api.rerender('2e9101ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/receivableManagementSite/billCollection/cmp/batchNumberDetail.vue"
export default component.exports